import { render, staticRenderFns } from "./add-article-modal.vue?vue&type=template&id=515d1dfe&scoped=true&"
import script from "./add-article-modal.vue?vue&type=script&lang=js&"
export * from "./add-article-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-article-modal.vue?vue&type=style&index=0&id=515d1dfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d1dfe",
  null
  
)

export default component.exports